export const questionsType = {
  multiChoice: "multi-choice",
  optionChoice: "option-choice",
  shortText: "short-text",
  text: "text"
};
